import React from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

// import "./assets/css/index.css"
import "./assets/less/index.less"

import { AuthProvider } from "./contexts/AuthContext"
import PrivateRoute from "./routes/PrivateRoute"
import AdminLayout from './layout/AdminLayout'
import AuthLayout from './layout/AuthLayout'
import UserStatus from './page/UserStatus'
import Page403 from './page/403'
import Page404 from './page/404'
import { ThemeProvider } from './contexts/ThemeContext'
import FireStoreProvider from "./contexts/FireStoreContext"
import Loader from "./utils/loader"

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <FireStoreProvider>
            <Switch>
              <Route path="/auth" component={AuthLayout} />
              <Route path="/status" component={UserStatus} />
              <Route path="/403" component={Page403} />
              <PrivateRoute path="/" component={AdminLayout} />
              <Route path="*" component={Page404} />
            </Switch>
          </FireStoreProvider>
        </AuthProvider>
        <Loader />
      </ThemeProvider>
    </Router>
  )
}

export default App
